window.selectorModule = (() => {
  function initalizeCollectionSelector() {
    const collections = document.querySelectorAll(".collection_selector-item");

    collections.forEach((item) => {
      item.addEventListener("click", () => {
        if (item.classList.contains("selected")) {
          // If already selected, do nothing
          return;
        }
        // Remove the "selected" class from all items
        collections.forEach((otherItem) => {
          otherItem.classList.remove("selected");
        });

        // Toggle the "selected" class on the clicked item
        item.classList.toggle("selected");

        // Get the ID of the clicked item
        const itemId = item.id;
        const itemNumber = itemId.replace("collection", "");

        // Find all elements with class .js-selector
        const collectionSliders = document.querySelectorAll(".js-collection");

        // Loop through all .js-selector elements
        collectionSliders.forEach((selector) => {
          // Get the ID of the .js-selector element
          const selectorId = selector.getAttribute("slide-data");
          console.log(selectorId);

          // Check if the selector ID matches the format 'slide<number>'
          if (selectorId === "slide" + itemNumber) {
            // Toggle the .js-hidden class on the matched element
            selector.classList.toggle("js-hidden");
          } else {
            // Ensure other elements are hidden
            selector.classList.add("js-hidden");
          }
        });
      });
    });
  }

  return {
    init: initalizeCollectionSelector,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  window.selectorModule.init();
});
